/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'YES_ONSITE_EATING_AREA_ONLY',
        'YES_ONSITE_CANTEEN_ONLY',
        'YES_ONSITE_CANTEEN_AND_EATING_AREA',
        'NO_NO_ONSITE_CANTEEN_OR_EATING_AREA',
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    is_there_an_onsite_canteeneating_area: valueSchema,
  },
}
